class WaitlistModal extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#WaitlistForm');
    this.submitButton = this.querySelector('.waitlist-modal__submit');
    this.submitText = this.querySelector('.waitlist-modal__submit-text');
    this.submitLoading = this.querySelector('.waitlist-modal__submit-loading');
    this.successMessage = this.querySelector('.waitlist-modal__message--success');
    this.errorMessage = this.querySelector('.waitlist-modal__message--error');
    
    this.init();
  }

  init() {
    // Close on overlay click
    this.querySelectorAll('[data-close-modal]').forEach(button => {
      button.addEventListener('click', () => this.close());
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.hasAttribute('hidden')) {
        this.close();
      }
    });

    // Form submission
    if (this.form) {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    // Open modal triggers
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-open-waitlist]') || e.target.closest('[data-open-waitlist]')) {
        e.preventDefault();
        this.open();
      }
    });
  }

  open() {
    this.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    
    // Focus first input
    const firstInput = this.querySelector('input, select');
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100);
    }
  }

  close() {
    this.setAttribute('hidden', '');
    document.body.style.overflow = '';
    this.resetForm();
  }

  resetForm() {
    if (this.form) {
      this.form.reset();
    }
    this.hideMessages();
    this.setLoading(false);
  }

  hideMessages() {
    if (this.successMessage) this.successMessage.setAttribute('hidden', '');
    if (this.errorMessage) this.errorMessage.setAttribute('hidden', '');
  }

  setLoading(loading) {
    if (loading) {
      this.submitButton.disabled = true;
      if (this.submitText) this.submitText.setAttribute('hidden', '');
      if (this.submitLoading) this.submitLoading.removeAttribute('hidden');
    } else {
      this.submitButton.disabled = false;
      if (this.submitText) this.submitText.removeAttribute('hidden');
      if (this.submitLoading) this.submitLoading.setAttribute('hidden', '');
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.hideMessages();
    this.setLoading(true);

    const formData = new FormData(this.form);
    const email = formData.get('email');
    const zodiac = formData.get('zodiac');
    const newsletter = formData.get('newsletter') === 'on';
    const productId = this.form.getAttribute('data-product-id');
    const productTitle = this.form.getAttribute('data-product-title');

    // Prepare data for Shopify contact form
    const contactData = {
      form_type: 'contact',
      utf8: '✓',
      'contact[email]': email,
      'contact[body]': `Waitlist Signup\n\nEmail: ${email}\nZodiac Sign: ${zodiac || 'Not provided'}\nNewsletter: ${newsletter ? 'Yes' : 'No'}\nProduct: ${productTitle || 'General'}\nProduct ID: ${productId || 'N/A'}`
    };

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(contactData)
      });

      if (response.ok) {
        this.showSuccess();
        this.form.reset();
        
        // Track event (if analytics is set up)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'waitlist_signup', {
            'event_category': 'engagement',
            'event_label': productTitle || 'general'
          });
        }
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      console.error('Waitlist submission error:', error);
      this.showError();
    } finally {
      this.setLoading(false);
    }
  }

  showSuccess() {
    if (this.successMessage) {
      this.successMessage.removeAttribute('hidden');
      this.successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    
    // Auto-close after 3 seconds
    setTimeout(() => {
      this.close();
    }, 3000);
  }

  showError() {
    if (this.errorMessage) {
      this.errorMessage.removeAttribute('hidden');
      this.errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

customElements.define('waitlist-modal', WaitlistModal);

